// Labels for the Reporting page's "look up a contact" handle-time view
// (GET /api/admin/reporting/contact-handle-time). Kept apart from the page so
// the wording is unit tested (ui/test/contactHandleTimeline.test.js).

const PAUSE_LABEL = {
  confirmed: 'Still-working check-in, answered',
  away: 'Away (page went silent, then returned)',
  conversation_closed: 'Closed while the check-in was open',
  released: 'Check-in answered No, or the claim ended',
  timeout: 'Check-in unanswered for 30 minutes',
}

const RELEASE_LABEL = {
  released: 'Released',
  stale_timeout: 'Went stale (no signal for 120 minutes)',
  taken_over: 'Taken over by someone else',
  auto_requeued: 'Parked contact re-queued automatically',
  returned_to_queue: 'Returned to the queue',
}

export function pauseLabel(resolution) {
  return resolution == null ? 'Still open' : (PAUSE_LABEL[resolution] ?? resolution)
}

export function releaseLabel(reason) {
  return reason == null ? 'Still open' : (RELEASE_LABEL[reason] ?? reason)
}

export function eventLabel(event) {
  return event.kind === 'manual_close' ? 'Closed by hand' : `Decision${event.intent ? ` (${event.intent})` : ''}`
}

// Eastern time, the same days the reports use.
export function formatEt(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('en-US', {
    timeZone: 'America/New_York', month: 'numeric', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit', second: '2-digit',
  })
}

// Minutes with one decimal, for a pause row ("95.1 min"); null while open.
export function formatMinutes(minutes) {
  return typeof minutes === 'number' && Number.isFinite(minutes) ? `${minutes.toFixed(1)} min` : '—'
}
